import React, {Component} from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { postNote } from '../../../actions/generalnotes'

// import styles
import './generalnotesmodal.scss'

// import components
import Modal from '../../components/Modal'

import Textarea from '../../elements/textarea'
import { ModalIcons } from '../../elements/icons'

// Utils
import { translation } from '../../../utils/helpers'

class GeneralNotesModal extends Component {

  constructor (props) {
    super(props)
    this.state = {
      show: false,
      showEdit: false,
      note: props.note,
      standardNotes: [],
      isLoading: false,
      error: ''
    }
    this.manipulateNote = this.manipulateNote.bind(this)
    this.onInputChange = this.onInputChange.bind(this)
  }

  componentWillReceiveProps (props) {
    if (props.show !== this.state.show) {
      this.setState({
        show: props.show,
        note: {
          ...this.state.note,
          ...props.note
        },
        isLoading: false,
        error: ''
      })
    }
  }

  manipulateNote (e) {
    e.preventDefault()
    this.setState({ isLoading: true, error: '' })

    setTimeout(() => {
      if (this.validateInputs()) {
        // Edit note
        // console.log('post', this.state.note)
        this.props.postNote(this.state.note).then((res) => {
          this.props.onSuccess(res.data)
          this.props.onClose(false)
          // Toastr
          // window.toastr.success(translation('1931'), translation('13424'))
        }, (err) => {
          if (err) {
            this.setState({
              isLoading: false
            })
            // Toastr
            window.toastr.error(translation('960'), translation('216'))
          }
        })
      } else {
        this.setState({
          isLoading: false
        })
        window.toastr.error(translation('13430'), translation('216'))
      }
    }, 50)
  }

  validateInputs () {
    if (this.state.note.Note === '') {
      return false
    }
    return true
  }

  onInputChange (e) {
    // called at "onClick" for checkbox... for some reason "onChange" doesn't work here
    this.setState({
      note: {
        ...this.state.note,
        Note: e.target.value
      }
    })
  }

  render () {
    if (typeof this.props.note.Note === 'undefined') return null

    let modalTitle = translation('13356')
    let buttonText = translation('13358')
    if (typeof this.props.note.IsMine !== 'undefined') {
      buttonText = translation('13357')
      modalTitle = translation('13357')
    }

    let bottomBarProps = {
      disabled: this.state.isLoading,
      actionLabelText: buttonText,
      onActionClick: this.manipulateNote
    }

    return (
      <div className='notes_modal'>
        <Modal {...this.props} header={modalTitle} icon={ModalIcons.Note} bottomBarProps={bottomBarProps}>
          {this.state.error && <div className='alert alert-danger'>{this.state.error}</div>}
          <Textarea name='Note' onChange={this.onInputChange} value={this.state.note.Note} />
        </Modal>
      </div>
    )
  }
}

GeneralNotesModal.propTypes = {
  postNote: PropTypes.func.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, { postNote })(GeneralNotesModal)



// WEBPACK FOOTER //
// ./src/app/shared/modals/GeneralNotesModal/index.js